import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$orgSlug/")({
	component: OrgIndex,
});

/** Bare org URL (/<orgSlug>) → the organization's workspaces list. */
function OrgIndex() {
	const { orgSlug } = Route.useParams();
	return <Navigate to="/$orgSlug/workspaces" params={{ orgSlug }} replace />;
}
